import { get, find, isEmpty, isEqual } from 'lodash';

import { ISite } from '../types/portal/company/site.type';
import {
  DEPARTMENT_CODE,
  DEPARTMENT_CODE_NOT_CONFIGURED,
} from '../services/transfer/transfer-constants';

const getSiteDepartmentCode = (site: ISite): string => {
  const siteMetadata = get(site, 'metadata', []);
  const departmentCode = find(siteMetadata, (metadata) =>
    isEqual(metadata.name, DEPARTMENT_CODE),
  )?.value;

  return isEmpty(departmentCode)
    ? DEPARTMENT_CODE_NOT_CONFIGURED
    : departmentCode;
};

export { getSiteDepartmentCode };
